import { api } from "technical/api";

export default async function deleteScenario(
  tenant: string,
  scenarioRef: number
) {
  await api(tenant).delete(`/v1/scenarios/${scenarioRef}`);
}
